

// https://web.archive.org/web/20250209115645/https://personal.sron.nl/~pault/
export const PAUL_TOL_COLORBLIND_SCALE: string[] = ['#332288', '#117733', '#44AA99', '#88CCEE', '#DDCC77', '#CC6677', '#AA4499', '#882255'];

// https://web.archive.org/web/20210108233739/http://jfly.iam.u-tokyo.ac.jp/color/
export const OKABE_AND_ITO_COLORBLIND_SCALE: string[] = ['#E69F00', '#56B4E9', '#009E73', '#F0E442', '#0072B2', '#D55E00', '#CC79A7', '#999999'];
